import { StatusPill, type StatusPillSize } from '@/components/ui/status-pill';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';
import type { ActiveBoon } from '@danda/shared';

interface BoonBadgeProps {
  boon: ActiveBoon;
  size?: StatusPillSize;
  className?: string;
}

/**
 * Green pill naming a party-wide boon (e.g. "INFERNAL VIGOR"), with its
 * mechanical effects on hover. Emerald rather than the health-state green so a
 * buff never reads as an UNINJURED badge.
 */
export function BoonBadge({ boon, size = 'xs', className }: BoonBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <StatusPill
            size={size}
            className={`bg-emerald-600 text-white uppercase cursor-help ${className ?? ''}`}
          >
            {boon.name}
          </StatusPill>
        </TooltipTrigger>
        <TooltipContent>
          {boon.effects.map((effect) => (
            <div key={effect}>{effect}</div>
          ))}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
